<template>
  <div class="smi">
    <h3 class="smi-title">
      <slot name="title"/>
    </h3>
    <div class="smi-content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'SummarizationItem',
  props: {
    title: {
      type: String,
    },
  },
};
</script>
